import { colors } from '@globals/themes/defaultTheme'
import { Recognition } from '@kudos/http-client'
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined'
import Stack from '@mui/material/Stack'
import { shuffle } from 'lodash/fp'
import KudosTvCard from '../KudosTvCard'
import SenderAndReceivers from '../sendersAndRecievers/SenderAndReceivers'
import TvRecognitionContent from './TvRecognitionContent'
type TvRecognitionProps = {
  recognition: Recognition
}

const TvRecognition: React.FC<TvRecognitionProps> = ({ recognition }) => {
  const shuffledArray = shuffle(recognition.sendTo)
  return (
    <KudosTvCard
      postedDate={recognition.createdAt}
      primaryColor={colors.goldPrimary}
      icon={<StarBorderOutlinedIcon />}
      postContent={
        <Stack direction="row" justifyContent="space-between" useFlexGap gap={10} pr={2}>
          <Stack direction="row">
            <SenderAndReceivers
              sender={recognition.sender}
              receivers={shuffledArray}
              textColor={colors.grayPrimary}
            />
          </Stack>
          <Stack flexGrow={1}>
            <TvRecognitionContent recognition={recognition} />
          </Stack>
        </Stack>
      }
    />
  )
}

export default TvRecognition
